export default function interpolate(template, values) {
  return String(template ?? '').replace(
    /\{(\w+)\}/g,
    (_, key) => values[key] ?? '',
  );
}
